import React, { memo } from "react";
import { SvgIcon } from "@mui/material";

interface MacbookDeviceIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const MacbookDeviceIcon: React.FC<MacbookDeviceIconProps> = ({
  className,
  width = 24,
  height = 24,
}) => {
  return (
    <SvgIcon className={className} style={{ width, height }} viewBox="0 0 143 117" fill="none">
      <path
        d="M130.002 84.5V27.3C130.002 20.0193 130.002 16.379 128.585 13.5981C127.339 11.152 125.35 9.16324 122.904 7.91693C120.123 6.5 116.483 6.5 109.202 6.5H33.8019C26.5212 6.5 22.8809 6.5 20.1001 7.91693C17.6539 9.16324 15.6652 11.152 14.4189 13.5981C13.002 16.379 13.002 20.0193 13.002 27.3V84.5M23.8353 110.5H119.168C123.198 110.5 125.213 110.5 126.866 110.057C131.353 108.855 134.857 105.351 136.059 100.864C136.502 99.2114 136.502 97.1964 136.502 93.1664C136.502 91.1514 136.502 90.1439 136.28 89.3178C135.68 87.0746 133.927 85.3222 131.684 84.7216C130.858 84.5 129.85 84.5 127.835 84.5H15.1686C13.1537 84.5 12.1462 84.5 11.3196 84.7216C9.07654 85.3222 7.32446 87.0746 6.72341 89.3178C6.50195 90.1439 6.50195 91.1514 6.50195 93.1664C6.50195 97.1964 6.50195 99.2114 6.94493 100.864C8.14697 105.351 11.6511 108.855 16.1373 110.057C17.7904 110.5 19.8054 110.5 23.8353 110.5Z"
        stroke="currentColor"
        strokeWidth="13"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export default memo(MacbookDeviceIcon);
